import moment from "moment/moment";

export default function calculateNight (checking, checkout) {
  if (!checking || !checkout) {
    return 'N/A'
  }

  var start = moment(checking, 'YYYY-MM-DD');
  var end  = moment(checkout, 'YYYY-MM-DD');
  //Difference in number of days
  var duration = moment.duration(end.diff(start));
  // return moment(checkout, 'YYYY-MM-DD').format("DD") - moment(checking, 'YYYY-MM-DD').format("DD");
  return Math.round(duration.asDays());
}



// WEBPACK FOOTER //
// ./src/app/filters/calculateNight.js